module.exports = __webpack_public_path__ + "img/vip.e0af43af.png";